import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ChevronRightIcon, TagIcon } from '@heroicons/react/solid';
import { selectVouchersByMenuItemId } from 'containers/Home/selectors';
import { selectStoreConfig } from 'containers/Layout/selectors';
import { getBadgeLabel } from 'helpers/getOffersSections';
import isVoucherAvailableAt, {
  getVoucherCheckMoment,
} from 'helpers/isVoucherAvailableAt';
import './ItemVoucherOffers.css';

export default function ItemVoucherOffers({ menuItemId, onClickOffer }) {
  const vouchersByMenuItemId = useSelector(selectVouchersByMenuItemId);
  const currentOrder = useSelector((state) => state.homeReducer.currentOrder);
  const { orderType, isFutureDeliveryDate, deliveryDate } = currentOrder || {};
  const { currency = '', timeZone } = useSelector(selectStoreConfig) || {};

  const offers = useMemo(() => {
    const matches = vouchersByMenuItemId[menuItemId];
    if (!matches?.length) return [];

    const checkMoment = getVoucherCheckMoment(
      { isFutureDeliveryDate, deliveryDate },
      timeZone
    );
    return matches
      .filter(
        ({ voucher }) =>
          (!orderType || voucher.orderTypeKeys?.includes(orderType)) &&
          isVoucherAvailableAt(voucher, checkMoment, timeZone)
      )
      .map(({ voucher }) => {
        const badge = getBadgeLabel(voucher, currency);
        const title = voucher.voucherHeading || badge;
        return {
          id: voucher._id,
          title,
          meta: title === badge ? '' : badge,
        };
      });
  }, [
    vouchersByMenuItemId,
    menuItemId,
    orderType,
    isFutureDeliveryDate,
    deliveryDate,
    timeZone,
    currency,
  ]);

  if (!onClickOffer || !offers.length) return null;

  return (
    <div className='itemOffers'>
      <p className='itemOffers__label'>
        {offers.length > 1
          ? `Part of ${offers.length} offers`
          : 'Part of an offer'}
      </p>
      <ul className='itemOffers__list'>
        {offers.map((offer) => (
          <li key={offer.id}>
            <button
              type='button'
              className='itemOffer'
              onClick={() => onClickOffer({ voucherId: offer.id, menuItemId })}
            >
              <span className='itemOffer__icon' aria-hidden='true'>
                <TagIcon />
              </span>
              <span className='itemOffer__text'>
                <span className='itemOffer__title'>{offer.title}</span>
                {offer.meta && (
                  <span className='itemOffer__meta'>{offer.meta}</span>
                )}
              </span>
              <ChevronRightIcon
                className='itemOffer__chevron'
                aria-hidden='true'
              />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
